import { Autocomplete, TextField } from '@mui/material';
import noteTransposer, { TransposeKey } from '~/sites/music/utils/NoteTransposer';
import { useChartEditContext } from './ChartEditContext';
import TagsInput from '~/shared/components/tags/TagsInput';
import { reactQueryClient } from '~/shared/contexts/CommonAppContext';
import { Chart } from '~/shared/types/chart';

export default function TopInputs() {

  const {
    chart,
    genreCategoryId,
    artistCategoryId,
    styleCategoryId,
    editedChart,
    setEditedChart
  } = useChartEditContext()

  const isNewChart = !chart.id
  const isPersistedChart = !!chart.id

  const reloadAll = ({ tagCategoryId }: { tagCategoryId: number }) => {
    reactQueryClient.invalidateQueries({ queryKey: ['charts'] });
    reactQueryClient.invalidateQueries({ queryKey: ['charts', chart.id] });
    reactQueryClient.invalidateQueries({ queryKey: ['tags', tagCategoryId] });
  }

  const handleChange = (
    _event: React.SyntheticEvent,
    value: TransposeKey | null,
  ) => {
    if (!value) return;
    setEditedChart(draft => { draft.key = value });
  };

  return (
    <div className="flex flex-wrap gap-2 mb-1">
      <div className="flex-1">
        <TextField
          fullWidth
          variant="filled"
          label="Song Title"
          name="song_title"
          value={editedChart.song_title || ''}
          onChange={(e) => setEditedChart(draft => { draft.song_title = e.target.value })}
        />
      </div>
      <div className="flex-1">
        <Autocomplete
          disableClearable
          options={noteTransposer.keys()}
          value={editedChart.key ?? null}
          onChange={handleChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="filled"
              label={'Song Key'}
            />
          )}
        />
      </div>
      {isPersistedChart && (
        <>
          <div className="flex-1">
            <TagsInput
              entity={chart}
              tagCategoryId={artistCategoryId}
              inputLabel={'Song Artist(s)'}
              afterChange={() => reloadAll({ tagCategoryId: artistCategoryId })}
            />
          </div>
          <div className="flex-1">
            <TagsInput
              entity={chart}
              tagCategoryId={styleCategoryId}
              inputLabel={'Song Style'}
              afterChange={() => reloadAll({ tagCategoryId: styleCategoryId })}
            />
          </div>
          <div className="flex-1">
            <TagsInput
              entity={chart}
              tagCategoryId={genreCategoryId}
              inputLabel={'Song Era'}
              afterChange={() => reloadAll({ tagCategoryId: genreCategoryId })}
            />
          </div>
        </>
      )}
    </div>
  );
}; 